import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconGlobeLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.994 3a9 9 0 0 0 .002 18h.006a9 9 0 0 0 .005-18h-.014ZM12 5.484c-.802 1.086-1.654 2.938-1.946 5.147-.016.122-.03.245-.043.369h3.978a11.966 11.966 0 0 0-.043-.37C13.654 8.423 12.802 6.57 12 5.485ZM15.998 11a14.062 14.062 0 0 0-.07-.63c-.248-1.887-.865-3.627-1.62-4.98A7.009 7.009 0 0 1 18.93 11h-2.931Zm-1.978 2H9.98c.133 1.81.722 3.69 2.02 5.433A10.227 10.227 0 0 0 14.02 13Zm.263 5.62a12.229 12.229 0 0 0 1.74-5.62h2.906a7.009 7.009 0 0 1-4.646 5.62Zm-4.566 0A12.23 12.23 0 0 1 7.977 13H5.07a7.009 7.009 0 0 0 4.646 5.62ZM8.07 10.37c.25-1.887.866-3.627 1.62-4.98A7.009 7.009 0 0 0 5.071 11h2.932c.018-.213.04-.423.068-.63Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconGlobeLine);
export default Memo;
